<template>
  <div class="header">
    <div class="container">
      <div class="action">
        <div
          :class="['box',{'active':currPath==='/contact'}]"
          @click="topage('contact')"
        >
          <img
            src="/imgs/portal/contact@2x.png"
            alt=""
          >联系我们
        </div>
        <div
          class="box"
          @click="onLogin"
        >
          <img
            src="/imgs/portal/login@2x.png"
            alt=""
          >登录注册
        </div>
      </div>
    </div>
    <div class="container">
      <div class="nav">
        <img
          src="/imgs/portal/logo_white.png"
          alt=""
          @click="topage('/')"
        >
        <div :class="['nav-item',{'active':caseList.includes(currPath)}]">我们的方案
          <div class="nav-list">
            <p @click="topage('/core')">核心企业</p>
            <p @click="topage('/institution')">金融机构</p>
            <p @click="topage('/chain')">供应商 / 经销商</p>
          </div>
        </div>
        <div :class="['nav-item',{'active':advantageList.includes(currPath)}]">我们的优势
          <div class="nav-list">
            <p @click="topage('product')">平台产品</p>
            <p @click="topage('service')">供应链金融服务</p>
          </div>
        </div>
        <div :class="['nav-item',{'active':aboutList.includes(currPath)}]">关于群星
          <div class="nav-list">
            <p @click="topage('about')">公司介绍</p>
            <p @click="topage('news')">群星资讯</p>
            <p @click="topage('join')">加入群星</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // props: {
  //   onLogin: Function
  // },
  data () {
    return {
      caseList: ['/core', '/institution', '/chain'],
      advantageList: ['/product', '/platform', '/service'],
      aboutList: ['/about', '/news', '/join']
    }
  },
  methods: {
    topage (way) {
      this.$router.push(way)
    },
    onLogin () {
      location.href = '/dcf/minisite.html#/'
    }
  },
  computed: {
    currPath () {
      return this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  font-size: 14px;
  color: #ffffff;
  .container {
    background: #444444;
    &:nth-child(2) {
      background: rgba(45, 45, 45, 0.98);
    }
    .action {
      width: 1000px;
      height: 44px;
      margin: 0 auto;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .box {
        margin-right: 24px;
        cursor: pointer;
        opacity: 0.6;
        transition: opacity 0.5s;
        &.active {
          opacity: 1;
        }
        &:hover {
          opacity: 1;
        }
        img {
          width: 18px;
          position: relative;
          top: 3px;
          margin-right: 8px;
        }
      }
    }
    .nav {
      width: 1000px;
      height: 52px;
      line-height: 52px;
      margin: 0 auto;
      img {
        width: 91px;
        position: relative;
        top: 10px;
        margin-right: 306px;
        cursor: pointer;
      }
      .nav-item {
        display: inline-block;
        margin-left: 100px;
        opacity: 0.6;
        transition: opacity 0.5s;
        position: relative;
        cursor: pointer;
        &.active {
          opacity: 1;
        }
        &:hover {
          opacity: 1;
          .nav-list {
            visibility: visible;
            opacity: 1;
          }
        }
        .nav-list {
          position: absolute;
          left: -50%;
          background: #303030;
          width: 200%;
          opacity: 0;
          visibility: hidden;
          text-align: center;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          padding: 0 0 10px;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
          transition: all 0.5s;
          transition-delay: all 0.5s;
          p {
            margin: 0;
            line-height: 30px;
            opacity: 0.6;
            transition: opacity 0.5s;
            &:hover {
              opacity: 1;
              background: #505050;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Header.vue?ae8d723a